var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94053e-05 17.0526L17.0526 0L18 0.947367L0.947387 18L1.94053e-05 17.0526Z",
    fill: "#00C853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.947367 2.22003e-05L18 17.0526L17.0526 18L0 0.947389L0.947367 2.22003e-05Z",
    fill: "#00C853"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEx);
export default __webpack_public_path__ + "static/media/green-ex.70271fb76662192f799cf5ee3c810571.svg";
export { ForwardRef as ReactComponent };